import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { translator } from 'mage-i18n';
import { Link, SpacerVertical } from '@klarna/bubble-ui';
import { HorizontalWrapper, defaultContainerPropTypes } from 'moet-core';

import { CallToActionButton, ContainerTemplate } from '@/components';
import { getMerchantAwareTranslator, getMerchantAwareArrayTranslator } from '@/selectors/merchant';

const tPrefix = 'products-fe.containers.recollection_introduction';

export class Introduction extends React.Component {
  render() {
    const { error, onNext, t, tArrayMerchantAware, tMerchantAware } = this.props;

    return (
      <ContainerTemplate
        title={tMerchantAware(`${tPrefix}.title`)}
        subtitle={tArrayMerchantAware(`${tPrefix}.subtitle`).map(({ text, link }, index) =>
          link ? (
            <Link key={index} href={link} target="_blank">
              {text}
            </Link>
          ) : (
            <span key={index}>{text}</span>
          ),
        )}
        error={error}
      >
        <SpacerVertical spaceToken="space/600" />
        <HorizontalWrapper display="inline-flex" alignItems="center" justifyContent="flex-end">
          <CallToActionButton tabIndex={1} onClick={onNext}>
            {t(`${tPrefix}.buttons.next`)}
          </CallToActionButton>
        </HorizontalWrapper>
      </ContainerTemplate>
    );
  }
}

Introduction.propTypes = {
  ...defaultContainerPropTypes,
  t: PropTypes.func.isRequired,
  tArrayMerchantAware: PropTypes.func.isRequired,
  tMerchantAware: PropTypes.func.isRequired,
};

const WrappedComponent = compose(
  connect(state => ({
    t: translator(state),
    tArrayMerchantAware: getMerchantAwareArrayTranslator(state),
    tMerchantAware: getMerchantAwareTranslator(state),
  })),
  // withCapabilityBeforeNext({ cap: CAPS.V2_MERCHANTS_STORE_DETAILS_PUT }),
)(Introduction);

export default WrappedComponent;
